import { adminHttp } from './adminHttp'

/** API 키 관리 */
export const adminApiKeyApi = {
  list: () =>
    adminHttp.get(
      '/admin/api-keys',
      b => b.data?.apiKeys ?? [],
      'API 키 조회 실패'
    ),

  create: (payload: unknown) =>
    adminHttp.post('/admin/api-keys', payload, b => b.data, 'API 키 생성 실패'),

  update: (keyId: string, payload: unknown) =>
    adminHttp.put(
      `/admin/api-keys/${encodeURIComponent(keyId)}`,
      payload,
      b => b.data,
      'API 키 수정 실패'
    ),

  remove: (keyId: string) =>
    adminHttp.delete(
      `/admin/api-keys/${encodeURIComponent(keyId)}`,
      () => undefined,
      'API 키 삭제 실패'
    ),

  usage: (keyId: string) =>
    adminHttp.get(
      `/admin/api-keys/usage/${encodeURIComponent(keyId)}`,
      b => b.data,
      'API 키 사용량 조회 실패'
    ),
}

export default adminApiKeyApi
